module.exports = __webpack_public_path__ + "img/information.4c025850.png";